// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FlipperAsync$LiteracyplanetClientSxActivity from "./FlipperAsync.res.mjs";

function use(contentMd5, existingAttemptId, insertAttempt, updateActivityCompleted, updateState, insertResponse) {
  var api = React.useRef({
        pushEvent: (function (param) {
            
          }),
        idle: (function () {
            return Promise.resolve();
          })
      });
  React.useEffect((function () {
          api.current = FlipperAsync$LiteracyplanetClientSxActivity.make(contentMd5, existingAttemptId, insertAttempt, updateActivityCompleted, updateState, insertResponse);
        }), []);
  var onQuestionFailed = function (questionIndex, state, answer, responsesCorrect, responsesComplete) {
    api.current.pushEvent({
          TAG: "QuestionAnswered",
          questionIndex: questionIndex,
          state: state,
          answer: answer,
          passed: false,
          responsesCorrect: responsesCorrect,
          responsesComplete: responsesComplete
        });
  };
  var onQuestionPassed = function (questionIndex, state, answer, responsesCorrect, responsesComplete) {
    api.current.pushEvent({
          TAG: "QuestionAnswered",
          questionIndex: questionIndex,
          state: state,
          answer: answer,
          passed: true,
          responsesCorrect: responsesCorrect,
          responsesComplete: responsesComplete
        });
  };
  var onActivityCompleted = function () {
    api.current.pushEvent("ActivityCompleted");
  };
  var onUpdateState = function (questionIndex, state) {
    api.current.pushEvent({
          TAG: "PageChange",
          questionIndex: questionIndex,
          state: state
        });
  };
  return [
          onQuestionPassed,
          onQuestionFailed,
          onActivityCompleted,
          onUpdateState
        ];
}

export {
  use ,
}
/* react Not a pure module */
